import { render, staticRenderFns } from "./CoachGameReport.vue?vue&type=template&id=41a2022a&scoped=true&"
import script from "./CoachGameReport.vue?vue&type=script&lang=ts&"
export * from "./CoachGameReport.vue?vue&type=script&lang=ts&"
import style0 from "./CoachGameReport.vue?vue&type=style&index=0&id=41a2022a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a2022a",
  null
  
)

export default component.exports